import {
  alphaOnly,
  dateValidator,
  digits,
  digitsAndSpace,
  sexValidator,
  speciesCodeValidator,
  ringSizeValidation,
  weightRingSizeValidation,
  localityValidation,
  numericValidator,
  plumageValidator,
  moultValidator,
  ageNumericValidator,
  broodValidator
} from "../Validations/MergeValidators";

const DataBaseValidation = (tableApi, data, setSnackBar) => {
  let mergeAllow = true;
  let warnUser = false;
  let errorMessages = [];

  const friendlyMessages = {
    ringNo: {
      empty: "Ring Number is required.",
      invalid: "Ring Number must contain only digits."
    },
    ringSize: {
      empty: "Ring Size is required.",
      invalid: "Ring Size is not valid."
    },
    speciesCode: {
      empty: "Species Code is required.",
      invalid: "Species Code is invalid. Expected format: XXXX-X"
    },
    species: {
      empty: "Scientific Name is required.",
      invalid: "Scientific Name must contain only alphabets."
    },
    date: {
      empty: "Date is required.",
      invalid: "Date format is invalid. Expected format: DD-MMM-YYYY (e.g., 03-Nov-1986)."
    },
    locality: {
      empty: "Locality is required. If unknown, please fill \"Unknown\"."
    },
    weight: {
      invalid: "Weight must be numeric (e.g., 123 or 123.45)."
    },
    wing: {
      invalid: "Wing must be numeric (e.g., 123 or 123.45)."
    },
    bills: {
      invalid: "Bill must be numeric (e.g., 123 or 123.45)."
    },
    tars: {
      invalid: "Tars must be numeric (e.g., 123 or 123.45)."
    },    
    moult: {
      invalid: "Moult must be empty or 0–10."
    },
    brood: {
      invalid: "Brood must be empty or 0–9."
    },
    plumage: {
      invalid: "Plumage must be empty or 0–9."
    },    
    age: {
      invalid: "Age must be empty or 0-7."
    }
  };

  for (let index in data) {
    const row = data[index];
    const objectKeys = Object.keys(row);
    const rowNo = parseInt(index) + 1;

    /* =========================
       REQUIRED / HARD VALIDATION
       ========================= */

    // RingNo
    if (!objectKeys.includes("RingNo")) {
      errorMessages.push(`Row ${rowNo} : Ring No Missing`);
      tableApi.selectCell(rowNo - 1, "RingNo");
      mergeAllow = false;
    } else {
      const ringNo = ('' + (row["RingNo"] || "")).trim();
      if (!ringNo) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.ringNo.empty}`);
        tableApi.selectCell(rowNo - 1, "RingNo");
        mergeAllow = false;
      } else if (digits(ringNo)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.ringNo.invalid}`);
        tableApi.selectCell(rowNo - 1, "RingNo");
        mergeAllow = false;
      }
    }

    // RingSize
    if (!objectKeys.includes("RingSize")) {
      errorMessages.push(`Row ${rowNo} : Ring Size Missing`);
      tableApi.selectCell(rowNo - 1, "RingSize");
      mergeAllow = false;
    } else {
      const ringSize = ('' + (row["RingSize"] || "")).trim();
      if (!ringSize) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.ringSize.empty}`);
        tableApi.selectCell(rowNo - 1, "RingSize");
        mergeAllow = false;
      } else if (!ringSizeValidation(ringSize)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.ringSize.invalid}`);
        tableApi.selectCell(rowNo - 1, "RingSize");
        mergeAllow = false;
      }
    }

    // SpeciesCode
    // if (objectKeys.includes("SpeciesCode")) {
    //   const speciesCode = ('' + (row["SpeciesCode"] || "")).trim();
    //   if (speciesCode && speciesCodeValidator(speciesCode)) {
    //     errorMessages.push(`Row ${rowNo} : ${friendlyMessages.speciesCode.invalid}`);
    //     tableApi.selectCell(rowNo - 1, "SpeciesCode");
    //     mergeAllow = false;
    //   }
    // }

    // SpeciesCode (Required + Invalid Check)
    if (objectKeys.includes("SpeciesCode")) {
      const speciesCode = ('' + (row["SpeciesCode"] || "")).trim();
      // Required check
      if (!speciesCode) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.speciesCode.empty}`);
        tableApi.selectCell(rowNo - 1, "SpeciesCode");
        mergeAllow = false;
      } else if (speciesCodeValidator(speciesCode)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.speciesCode.invalid}`);
        tableApi.selectCell(rowNo - 1, "SpeciesCode");
        mergeAllow = false;
      }
    }



    // Species (Scientific Name)
    if (objectKeys.includes("Species")) {
      const species = ('' + (row["Species"] || "")).trim();
      if (!species) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.species.empty}`);
        tableApi.selectCell(rowNo - 1, "Species");
        mergeAllow = false;
      } else if (alphaOnly(species)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.species.invalid}`);
        tableApi.selectCell(rowNo - 1, "Species");
        mergeAllow = false;
      }
    }

    // Locality
    if (objectKeys.includes("Locality")) {
      if (!localityValidation(row["Locality"])) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.locality.empty}`);
        tableApi.selectCell(rowNo - 1, "Locality");
        mergeAllow = false;
      }
    }

    // Date
    if (objectKeys.includes("Date")) {
      const date = ('' + (row["Date"] || "")).trim();
      if (!date) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.date.empty}`);
        tableApi.selectCell(rowNo - 1, "Date");
        mergeAllow = false;
      } else if (dateValidator(date)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.date.invalid}`);
        tableApi.selectCell(rowNo - 1, "Date");
        mergeAllow = false;
      }
    }

    // Plumage
    if (objectKeys.includes("Plumage")) {
      const plumage = ('' + (row["Plumage"] || "")).trim();
      if (plumage && plumageValidator(plumage)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.plumage.invalid}`);
        tableApi.selectCell(rowNo - 1, "Plumage");
        mergeAllow = false;
      }
    }

    // Moult
    if (objectKeys.includes("Moult")) {
      const moult = ('' + (row["Moult"] || "")).trim();
      if (moult && moultValidator(moult)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.moult.invalid}`);
        tableApi.selectCell(rowNo - 1, "Moult");
        mergeAllow = false;
      }
    }

    // Brood
    if (objectKeys.includes("Brood")) {
      const brood = ('' + (row["Brood"] || "")).trim();
      if (brood && broodValidator(brood)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.brood.invalid}`);
        tableApi.selectCell(rowNo - 1, "Brood");
        mergeAllow = false;
      }
    }


    /* =========================
       SOFT WARNINGS (ALLOW MERGE)
       ========================= */

    // Weight
    if (objectKeys.includes("Weight")) {
      const weight = ('' + (row["Weight"] || "")).trim();
      if (weight && numericValidator(weight)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.weight.invalid}`);
        tableApi.selectCell(rowNo - 1, "Weight");
        mergeAllow = false;
        // warnUser = true;
      }
      // Weight and RingSize validation
      if (objectKeys.includes("RingSize") && weight && row["RingSize"]) {
        if (weightRingSizeValidation(weight, row["RingSize"])) {
          warnUser = true;
        }
      }
    }

    // Wing
    if (objectKeys.includes("Wing")) {
      const wing = ('' + (row["Wing"] || "")).trim();
      if (wing && numericValidator(wing)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.wing.invalid}`);
        tableApi.selectCell(rowNo - 1, "Wing");
        mergeAllow = false;
        // warnUser = true;
      }
    }

    // Bills (check both "Bill" and "Bills" for compatibility)
    const billField = objectKeys.includes("Bill") ? "Bill" : (objectKeys.includes("Bills") ? "Bills" : null);
    if (billField) {
      const bills = ('' + (row[billField] || "")).trim();
      if (bills && numericValidator(bills)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.bills.invalid}`);
        tableApi.selectCell(rowNo - 1, billField);
        mergeAllow = false;
        // warnUser = true;
      }
    }

    // Tars
    if (objectKeys.includes("Tars")) {
      const tars = ('' + (row["Tars"] || "")).trim();
      if (tars && numericValidator(tars)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.tars.invalid}`);
        tableApi.selectCell(rowNo - 1, "Tars");
        mergeAllow = false;
        // warnUser = true;
      }
    }


    // Age
    if (objectKeys.includes("Age")) {
      const age = ('' + (row["Age"] || "")).trim();
      if (age && ageNumericValidator(age)) {
        errorMessages.push(`Row ${rowNo} : ${friendlyMessages.age.invalid}`);
        tableApi.selectCell(rowNo - 1, "Age");
        mergeAllow = false;
        // warnUser = true;
      }
    }

    // Sex
    if (objectKeys.includes("Sex")) {
      const sex = ('' + (row["Sex"] || "")).trim();
      if (sex && !sexValidator(sex)) {
        warnUser = true;
      }
    }
  }

  return { mergeAllow, warnUser, errorMessages };
};

export { DataBaseValidation };